<template>
<div>
    <div v-if="books.isSerial == 1">
        <div class="bookitem">
            <div class="playimg">
                <div class="playicon" @click="$store.dispatch('bookplay',books.bookId)"></div>
            </div>
            <router-link :to="{path:'/bookdetail',query:{bookId:books.bookId}}">
            
                <img class="faceimg" :src="books.faceImgPlay | objs" />
                <p class="f18">
                    <nobr>{{books.bookName}}</nobr>
                </p>
                <p class="f14"><span v-if="books.nationName != ''">[{{books.nationName}}]</span>{{books.author}}</p>
                <p><br /> </p>
             <!--   <p><span class="ludubi">{{books.priceTag || '0.00'}}</span> <span class="f12">{{books.listenCount}}已听</span></p> -->
            </router-link>
        </div>
    </div>
    <div v-else>
        <div class="bookitem">
            <router-link :to="{path:'/booklist',query:{listId:books.serialId}}">
                <img class="faceimg" :src="books.faceImgPlay | objs" />
                <p class="f18">
                    <nobr>{{books.bookName}}</nobr>
                </p>
                <p class="f14"><span v-if="books.nationName != ''">[{{books.nationName}}]</span>{{books.author}}</p>
                <p class="graybg"><span v-if="books.isLast==2">完结</span>（已更新至{{books.total}}期）</p>
              <!--  <p><span class="ludubi">{{books.priceTag}}</span> <span class="f12" v-if="books.listenCount != ''">{{books.listenCount}}已听</span></p> -->
            </router-link>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'BookItem',
    props: [
        "books"
    ]
}
</script>

<style scoped>
a {
    text-decoration: none;
}
.bookitem:hover .playimg{
    display: block !important;
}
.playimg {
    position: relative;
    z-index: 0;
    display: none;
}

.playimg .playicon {
    position: absolute;
    top: 30px;
    left: 30px;
    width: 60px;
    height: 60px;
    background-image: url(../assets/play.png);
    background-size:60px;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: 0.9;
    z-index: 1;
}
.playimg .playicon:hover{
    opacity: 0.6;
}
.playimg .pause {
    position: absolute;
    top: 0;
    left: 0;
    width: 190px;
    height: 190px;
    background-image: url(../assets/pause.png);
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
    opacity: 0.9;
    z-index: 1;
}
.bookitem {
    width: 33.3333%;
    float: left; 
    padding: 30px 0 0px 0;
    height: 140px;
}

.bookitem .faceimg {
    width: 120px;
    height: 120px;
    float: left;
    border: 1px;
    margin-right: 10px;
    background: rgba(210, 210, 210, 1);
    box-shadow: 1px 1px 10px 0px rgba(173, 195, 189, 0.43);
    border-radius: 2px;
    margin-right: 15px;
}
.bookitem .faceimg:hover{
    box-shadow: 1px 1px 10px 0px rgba(75, 204, 170, 0.5) !important;
}
.bookitem p {
    padding: 0;
    margin: 10px;
}

.f18 {
    height: 22px;
    word-break: keep-all;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(36, 41, 38, 1);
}

.f14 {
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
}

.f12 {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
    float: right;
}

.graybg {
    background: rgba(246, 247, 247, 1);
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
}

.graybg span {
    display: inline-block;
    padding: 2px 4px;
    background: rgba(75, 204, 170, 1);
    border-radius: 2px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 10px;
}

.ludubi {
    padding-right: 65px;
    margin-right: 15px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    height: 22px;
    background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 65px 18px;
    display: inline-block;
}
</style>
